import React from "react";
import { AuthLayout } from "@/components/auth/AuthLayout";
import { LoginForm } from "@/components/auth/LoginForm";
import { useTranslation } from "@/lib/i18n";
export default function LoginPage() {
  const { t } = useTranslation();
  return (
    <AuthLayout title={t('login_title')} subtitle={t('login_subtitle')}>
      <LoginForm />
    </AuthLayout>
  );
}